import { isArray, isPlainObject } from 'lodash';
import { logger } from '@sendpayments/js-utils';

export const reduce = (state, action) => {
  const { payload } = action;
  const { keys, entity } = payload || {};

  if (!payload) {
    logger.error('@sendpayments/react-shared/remote-data', `reducer/CREATE_ENTITY. payload need to be passed`, action);
  }

  if (!keys) {
    logger.error('@sendpayments/react-shared/remote-data', `reducer/CREATE_ENTITY. keys need to be passed`, action);
  }

  if (!entity) {
    logger.error('@sendpayments/react-shared/remote-data', `reducer/CREATE_ENTITY. entity need to be passed`, action);
  }

  let somethingHasChanged = false;

  const newState = Object.entries(state).reduce((acc, [prop, remoteData]) => {
    const { initialized, data, createdAt } = remoteData;

    const timestamp = createdAt ? +new Date(createdAt) : undefined;

    // we can get an entity that is an object in which we need to initialize data or create it inside an array.
    // or we can have an entity that is an array so we just need to create based on the tree initialState type

    if (keys.includes(prop)) {
      // only for new data cases create it
      if (
        initialized &&
        isArray(data) &&
        isPlainObject(entity) &&
        !data.some(({ id, type: typeEntity }) => id === entity.id && typeEntity === entity.type)
      ) {
        const newEntity = {
          createdAt: new Date().toISOString(),
          ...entity,
        };

        acc[prop] = {
          ...remoteData,
          data: [...data, newEntity],
          lastUpdated: timestamp,
        };

        somethingHasChanged = true;

        return acc;
      }

      if (initialized && isArray(data) && data.length === 0 && isArray(entity)) {
        const newEntityBase = { createdAt: new Date().toISOString() };

        acc[prop] = {
          ...acc[prop],
          data: entity.map((e) => ({
            ...newEntityBase,
            ...e,
          })),
          lastUpdated: timestamp,
        };

        somethingHasChanged = true;
      }

      if (initialized && isPlainObject(data) && Object.keys(data).length === 0 && isPlainObject(entity)) {
        const newEntity = {
          createdAt: new Date().toISOString(),
          ...entity,
        };

        acc[prop] = {
          ...acc[prop],
          data: newEntity,
          lastUpdated: timestamp,
        };

        somethingHasChanged = true;
      }

      if (initialized && isPlainObject(data) && isArray(entity)) {
        acc[prop] = remoteData;
      }

      return acc;
    }

    acc[prop] = remoteData;

    return acc;
  }, {});

  // only update the state when something actually changed
  return somethingHasChanged ? newState : state;
};
